const cat = [
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/categories/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_categories',
      resource: 'all',
    },
  },
  {
    path: '/new-categories',
    name: 'newCategories',
    component: () => import('@/views/categories/new/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_categories',
      resource: 'all',
    },
  },
  {
    path: '/new-categories/create',
    name: 'create-newCategories',
    component: () => import('@/views/categories/new/create.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_create_categories',
      resource: 'all',
    },
  },
  {
    path: '/new-categories/edit/:id',
    name: 'edit-newCategories',
    component: () => import('@/views/categories/new/edit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },
  {
    path: '/new-categories/editDetail/:id',
    name: 'edit-categoryDetail',
    component: () => import('@/views/categories/new/editDetail.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },

  {
    path: '/new-categories/editVariant/:id',
    name: 'edit-categoryVariant',
    component: () => import('@/views/categories/new/editVariant.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },
  {
    path: '/category-type-filters',
    name: 'categoryTypeFilters',
    component: () => import('@/views/categories/new/filterIndex.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_categories',
      resource: 'all',
    },
  },
  {
    path: '/category-type-filters/edit/:id',
    name: 'edit-categoryTypeFilters',
    component: () => import('@/views/categories/new/editCatTypeFilter.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },
  {
    path: '/category-types',
    name: 'categoryTypes',
    component: () => import('@/views/categories/new/typeIndex.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_categories',
      resource: 'all',
    },
  },
  {
    path: '/category-types/edit/:id',
    name: 'edit-categoryTypes',
    component: () => import('@/views/categories/new/editCatType.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },
  {
    path: '/categories/create',
    name: 'create-category',
    component: () => import('@/views/categories/create.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_create_categories',
      resource: 'all',
    },
  },
  {
    path: '/categories/edit/:id',
    name: 'edit-category',
    component: () => import('@/views/categories/edit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_categories',
      resource: 'all',
    },
  },
]

export default cat
